import { ACCESS_LEVEL } from './copy.js';

/**
 * Placeholder permission keys for People & Access (CT-5569).
 * contract TBD (ARP/backend, ARP-1480): the real catalog and where it comes from are not defined.
 * Components reference these constants, never a literal key.
 */
export const PERMISSIONS = Object.freeze({
  MEMBERS_VIEW: 'people-access.members.view',
  MEMBERS_INVITE: 'people-access.members.invite',
  MEMBERS_REMOVE: 'people-access.members.remove',
  /** Grant, edit and remove a member's direct studio access (CT-5612). */
  MEMBERS_MANAGE_ACCESS: 'people-access.members.manage-access',
  /** Dedicated permission to remove another Admin (CT-5611); name TBD (backend). */
  MEMBERS_REMOVE_ADMIN: 'people-access.members.remove-admin',
  MEMBERS_CHANGE_USER_TYPE: 'people-access.members.change-user-type',
  ROLES_VIEW: 'people-access.roles.view',
  ROLES_MANAGE: 'people-access.roles.manage',
  GROUPS_VIEW: 'people-access.groups.view',
  GROUPS_MANAGE: 'people-access.groups.manage',
  /** New group, and delete group: their own keys, not role checks (CT-5572); names TBD (backend). */
  GROUPS_CREATE: 'people-access.groups.create',
  GROUPS_DELETE: 'people-access.groups.delete',
});

/** Access levels of a permission, narrowest first: Own, Groups, Tenant. */
export const ACCESS_LEVELS = Object.freeze(Object.values(ACCESS_LEVEL));

/**
 * Level a permission takes when it is first turned on and `node.levels` does not say otherwise.
 * CT-5563: start at the most restricted level the permission accepts — Own, unless it
 * only offers a wider one. Which permissions are tenant-only is still for engineering to confirm.
 */
export const DEFAULT_ACCESS_LEVEL = ACCESS_LEVEL.OWN;

/** The level an Admin or Owner has on every permission by type: the widest one (Tenant). */
export const PRIVILEGED_ACCESS_LEVEL = ACCESS_LEVEL.TENANT;
